import global from '@/api/global'

import { post } from './http'

// export function ap (query) {
//   return http({
//     url: 'zwzhbcps/waybill/selectWaybill',
//     method: 'post',
//     data: query,
//     headers: {
//       'content-type': 'application/json;charset=UTF-8'
//     }
//   })
// }
var name = global.orderName
let order = global.orderName
var name1 = global.contractName
var crmServer3 = global.crmServer3
var signature = global.signature
// 新客户名称列表
export let getCustomerlistByTenant = p => {
  if (localStorage.getItem('isCutCrm3') == 1) {
    return post(`${crmServer3}/sCustomer/list`, p)
  } else {
  }
}
export const findContractByhcList = p => post(`/${signature}/contract/findContractByhcList`, p)// 非货主-合同管理
export const findContractByhList = p => post(`/${signature}/contract/findContractByhList`, p) // 货主-合同管理
export const getContractPdfShow = p => post(`/${name1}/api/contractSignature/getContractPdfShow`, p)
// 合同
export const getContractPdfForBusinessNo = p => post(`/${name1}/api/contractSignature/getContractPdfForBusinessNo`, p)
// 货物类型
export const dropDownList = p => post(`/${name}/cProductType/dropDownList`, p)
// 地址列表
export const sAddressList = p => post(`/${name}/sAddress/list`, p)
// 新增地址
export const sAddressAdd = p => post(`/${name}/sAddress/add`, p)
// 修改地址
export const sAddressUpdate = p => post(`/${name}/sAddress/update`, p)
// 删除地址
export const sAddressDelete = p => post(`/${name}/sAddress/delete`, p)

// 发布货源
export const orderAdd = p => post(`/${order}/sOrder/add`, p)
// 订单列表
export const orderList = p => post(`/${order}/sOrder/list`, p)
// 订单提交
export const submitSOrder = p => post(`/${order}/sOrder/submitSOrder`, p)
// 订单删除
export const orderDel = p => post(`/${order}/sOrder/delete`, p)
// 订单撤回
export const orderRecall = p => post(`/${order}/sOrder/recall`, p)
// 订单详情
export const orderDetail = p => post(`/${order}/sOrder/detail`, p)
// 修改订单
export const orderUpdate = p => post(`/${order}/sOrder/update`, p)
// 售后服务列表
export const sWayAfterSalesList = p => post(`/${order}/sWayAfterSales/list`, p)
// 售后撤回
export const sWayAfterSalesDel = p => post(`/${order}/sWayAfterSales/delete`, p)
// 查看处理结果
export const sWayAfterSalesDetail = p => post(`/${order}/sWayAfterSales/detail`, p)
// 获取服务费率
export const findDictByCode = p => post(`/${order}/sDict/findDictByCode`, p)
// 订单完成
export const manualCompleteOrder = p => post(`/${order}/way/manualCompleteOrder`, p)
// 异常记录查询（钱）
export const getExceptionReportingList = p => post(`/${order}/exceptionReporting/getExceptionReportingList`, p)
// 异常记录图片查看（钱）
export const sWayExsReportingPicture = p => post(`/${order}/exceptionReporting/sWayExsReportingPicture`, p)
// 官网海量货源接口（钱）
export const massiveSupplyList = p => post(`/${order}/sOrder/massiveSupplyList`, p)
// 长期货源-新建（平）
export const sPeriodGoodsAdd = p => post(`/${order}/sPeriodGoods/add`, p)
// 长期货源-列表（平）
export const sPeriodGoodsList = p => post(`/${order}/sPeriodGoods/list`, p)
// 长期货源-详情（平）
export const sPeriodGoodsDetail = p => post(`/${order}/sPeriodGoods/detail`, p)
// 长期货源-删除（平）
export const sPeriodGoodsDelete = p => post(`/${order}/sPeriodGoods/delete`, p)
// 长期货源-停启用（平）
export const sPeriodGoodsupdateStatus = p => post(`/${order}/sPeriodGoods/updateStatus`, p)
// 长期货源-己用次数列表（平）
export const sPeriodGoodsPpickList = p => post(`/${order}/sPeriodGoodsPpick/list`, p)
// 货主-订单管理导入（常）
export const impOrder = p => post(`/${order}/sOrder/impOrder`, p)
// 货主验证是签章是否授权（尚）
// export const checkEsignForOwner = p => post(`/${order}/sOrder/checkEsignForOwner`, p)
// 获取合同信息（尚）
export const getHzContractMouldMap = p => post(`/${order}/sOrder/getHzContractMouldMap`, p)
// 运单上报（尚）
export const uploadWlhyYdOrZj = p => post(`/${order}/way/uploadWlhyYdOrZj`, p)
// 发布货源签合同
export const getOwnerContract = p => post(`/${order}/sOrder/getOwnerContract`, p)
